const getPuedeCerrarTurno = async (idCaja, cierreCompartido) => {
  return "Se puede hacer el cierre con normalidad.";
};

const puedeCerrarTurno = {
  getPuedeCerrarTurno,
};

export default puedeCerrarTurno;
